export default __webpack_public_path__ + "static/media/111.8ed52584.png";